import correctingInterval from 'correcting-interval'

function newTimer(confMagicData, positionMagicData, onEnded) {
	let intervalId = null
	start()
	confMagicData.addChangeCb(function() {
		start()
	})
	function start() {
		if (intervalId) correctingInterval.clearCorrectingInterval(intervalId)
		let value = confMagicData.getValue()
		if (!value) {
			positionMagicData.setValue(null)
			return
		}
		let [startDate, startPosition, duration, period] = value
		let position = startPosition
		if (period !== 0) position += (Date.now() - startDate)/1000
		intervalId = correctingInterval.setCorrectingInterval(function() {
			if (period === 0) return
			position += period
			if (position > duration) position = duration
			if (positionMagicData) positionMagicData.setValue(position)
			if (position === duration) {
				period = 0
				if (onEnded) onEnded()
			}
		}, period*1000)
		positionMagicData.setValue(position)
	}
}

export default {
	newTimer: newTimer
}
